/* eslint-disable unicorn/filename-case */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @nx/enforce-module-boundaries */
import { SYSTEM_PROMPTS } from "@/client/services/llm/agent-prompt";
import { ChatCompletionOptions, ChatMessage } from "@/server/agent/zhipu/zhipu.types";

export const generateResumeTitle = async (resumeData: any): Promise<string> => {
  try {
    const messages: ChatMessage[] = [
      {
        role: "system",
        content: SYSTEM_PROMPTS.RESUME_TITLE_GENERATOR,
      },
      {
        role: "user",
        content: JSON.stringify(resumeData),
      },
    ];

    const requestOptions: ChatCompletionOptions = {
      model: "google/gemini-2.0-flash-001",
      messages,
      temperature: 0.2,
      top_p: 0.9,
      max_tokens: 100,
      stream: false,
    };

    const response = await fetch("/api/agent/zhipu/chat", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestOptions),
    });

    if (!response.ok) {
      throw new Error("生成简历名称失败");
    }

    const result = await response.json();
    const title = result.choices?.[0]?.message?.content?.trim();

    // 如果 AI 没有返回有效标题，使用后备方案
    if (!title) {
      return generateFallbackTitle(resumeData);
    }

    return title;
  } catch (error) {
    console.error("生成简历名称时出错:", error);
    return generateFallbackTitle(resumeData);
  }
};

// 后备方案：生成基础标题
const generateFallbackTitle = (resumeData: any): string => {
  const name = resumeData.basics?.name || "";
  const latestWork = resumeData.work?.[0]?.position || "";
  const timestamp = new Date().toLocaleDateString("zh-CN");

  if (name && latestWork) {
    return `${name}_${latestWork}_${timestamp}`;
  }

  if (name) {
    return `${name}的简历_${timestamp}`;
  }

  return `导入的简历_${timestamp}`;
};
